// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.admanagement.listingoperations.RentalManagerUserClaimableListingsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ClaimCustomerListingsRequestDto,
  ClaimCustomerListingsResponseDto,
  CompanyPropertyClaimingDto,
  CustomerClaimingEmailMessageInfoDto,
  CustomerHasNewPropertiesToClaimResponseDto,
  ReleaseCustomerListingsRequestDto,
  ReleaseCustomerListingsResponseDto,
  SalesProUserInfoDto,
} from '../..';

interface GetClaimablePropertiesParams {
  pageSize?: number;
  startUnitId?: number;
  unitId?: number;
}

export const RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Path =
  '/api/web/v1/users/adManagement/listingOperations/claimCustomerListings';

/**
 * Claim customer Listing
 */
export const RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings = (
  postData: ClaimCustomerListingsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ClaimCustomerListingsRequestDto, ClaimCustomerListingsResponseDto>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path =
  '/api/web/v1/users/adManagement/listingOperations/getClaimableProperties';

/**
 * Return CompanyId claimable properties
 */
export const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties = (
  getParams: GetClaimablePropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetClaimablePropertiesParams, never, CompanyPropertyClaimingDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path =
  '/api/web/v1/users/adManagement/customerMessage/getUserSalesProInfo';

/**
 * Return Logged User Sales Pro's Name and Email
 */
export const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<SalesProUserInfoDto>>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Path =
  '/api/web/v1/users/adManagement/listingOperations/releaseCustomerListings';

/**
 * Release customer Listing
 */
export const RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings = (
  postData: ReleaseCustomerListingsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ReleaseCustomerListingsRequestDto, ReleaseCustomerListingsResponseDto>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Path =
  '/api/web/v1/users/adManagement/customerMessage/sendClaimingSalesMessage';

/**
 * Sent customer message to sales pro's Email
 */
export const RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage = (
  postData: CustomerClaimingEmailMessageInfoDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CustomerClaimingEmailMessageInfoDto, void>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path =
  '/api/web/v1/users/adManagement/listingOperations/userHasNewPropertiesToClaim';

/**
 * check if user has new properties to claim
 */
export const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim = (client = getClient()) => {
  return httpFrontEndRequest<never, never, CustomerHasNewPropertiesToClaimResponseDto>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
